/* import __COLOCATED_TEMPLATE__ from './regional-opt-out-card.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import templateOnlyComponent from '@ember/component/template-only';

interface RegionalOptOutCardSignature {
  // No args needed for this component
}

const RegionalOptOutCard = templateOnlyComponent<RegionalOptOutCardSignature>();

export default RegionalOptOutCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::SecurityModelsDataSharing::RegionalOptOutCard': typeof RegionalOptOutCard;
  }
}
